import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import AddNewPackege from '../../components/admincomponents/AddPackege';

function AddPackege({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <AddNewPackege />            
    </>
  );
}

export default AddPackege;
